import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import '../AIMChat.css';

const AuthInterface = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleGoogleSignIn = async () => {
    setSigningIn(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin
        }
      });
      if (error) throw error;
    } catch (error) {
      console.error('Error signing in with Google:', error);
      alert('Failed to sign in with Google. Please try again.');
    } finally {
      setSigningIn(false);
    }
  };

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } catch (error) {
      console.error('Error signing out:', error);
      alert('Failed to sign out. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="aim-chat-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="aim-system-message">
          Loading...
        </div>
      </div>
    );
  }

  if (user) {
    return (
      <div className="aim-chat-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ textAlign: 'center', maxWidth: '400px' }}>
          <div className="aim-chat-header">
            <span className="aim-status-indicator aim-status-online"></span>
            Welcome, {user.user_metadata?.full_name || user.email}!
          </div>
          <div className="aim-messages-area" style={{ marginBottom: '15px' }}>
            <div className="aim-system-message">
              You are now signed in and ready to create and chat with your NeoBots!
            </div>
          </div>
          <div className="aim-button-group">
            <button className="aim-button" onClick={handleSignOut}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="aim-chat-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center', maxWidth: '400px' }}>
        <div className="aim-chat-header">
          <span className="aim-status-indicator aim-status-offline"></span>
          Welcome to NeoBots
        </div>
        <div className="aim-messages-area" style={{ marginBottom: '15px' }}>
          <div className="aim-system-message">
            Sign in with your Google account to start creating and chatting with AI bots!
          </div>
        </div>
        <div className="aim-button-group">
          <button 
            className="aim-send-button"
            onClick={handleGoogleSignIn}
            disabled={signingIn}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              margin: '0 auto'
            }}
          >
            {signingIn ? (
              'Signing In...'
            ) : (
              <>
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Sign in with Google
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthInterface; 